<template>
    <div class="issue-list">
      <el-table
        :data="issues"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        stripe
      >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          width="80">
        </el-table-column>
        <el-table-column
          prop="project.name"
          label="项目"
          width="150">
        </el-table-column>
        <el-table-column
          prop="status.name"
          label="状态"
          width="100">
        </el-table-column>
        <el-table-column
          prop="priority.name"
          label="优先级"
          width="100">
        </el-table-column>
        <el-table-column
          prop="subject"
          label="主题">
        </el-table-column>
        <el-table-column
          prop="assigned_to.name"
          label="指派给"
          width="120">
        </el-table-column>
        <el-table-column
          prop="created_on"
          label="创建时间"
          width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_on) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updated_on"
          label="更新时间"
          width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.updated_on) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </template>
  
  <script>
  export default {
    name: 'IssueList',
    props: {
      issues: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      handleSelectionChange(selection) {
        this.$emit('selection-change', selection)
      },
      formatDate(dateString) {
        if (!dateString) return ''
        const date = new Date(dateString)
        return date.toLocaleString()
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/IssueList.vue